export default {
  title: 'Partnerzy',
  search_placeholder: 'Szukaj partnera...',
  buttons: {
    default_price_list: 'Domyślny cennik',
    create_partner: 'Utwórz partnera',
  },
  columns: {
    name: 'Nazwa',
    restaurants: 'Restauracje',
    shop_domain: 'Domena sklepu',
    status: 'Status',
    earning_enabled: 'Zarobki włączone',
  },
  statuses: {
    invited: 'Zaproszony',
    active: 'Aktywny',
    suspended: 'Zawieszony',
  },
  actions: {
    edit: 'Edytuj',
    view_billing: 'Zobacz płatności',
    view_as_partner: 'Wyświetl jako partner',
    suspend: 'Zawieś',
    unsuspend: 'Przywróć',
  },
  suspension: {
    suspend_title: 'Zawiesić tego partnera?',
    suspend_description:
      'Wszyscy członkowie zespołu partnera zostaną dezaktywowani, a ich sesje unieważnione. Ich restauracje pozostają aktywne.',
    unsuspend_title: 'Przywrócić tego partnera?',
    unsuspend_description:
      'Wszyscy członkowie zespołu partnera zostaną reaktywowani i będą mogli się ponownie zalogować.',
  },
  toasts: {
    load_error: 'Nie udało się załadować partnerów.',
    suspended: 'Partner został zawieszony.',
    unsuspended: 'Partner został przywrócony.',
    suspension_error: 'Nie udało się zmienić statusu partnera.',
    view_as_error: 'Nie udało się otworzyć panelu partnera.',
  },
};
